<template>
  <div id="BlockedReport">
    <loading v-if="loadingRender"></loading>
    <panel Title="گزارش مسدودی‌ها" Des="از طریق این فرم میتوانید گزارشی از مسدودی حساب‌های خود را مشاهده نمائید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-lock"></i>
          گزارش مسدودی‌ها
        </h6>
      </template>
      <template slot="content">
    <div class="row">
      <div class="card p-3 m-3 border rounded Netpa-Shadow w-100" id="Date">
        <div class="row">
          <span class="badge badge-light w-100 p-2 m-2">لطفا حساب خود را انتخاب نمایید</span>
        </div>
        <div class="row">
          <div class="col-md-4 col-12 mt-2 text-right">
            <small>انتخاب حساب</small>
            <select v-if="IsLoad" @change="GetReport" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
              <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option v-for="item in this.ListModel" :key="item.id" :value="item.id">
                <span>{{ item.vcodeDesNo }} </span>
              </option>
            </select>
          </div>
          <!-- <div class="col-md-2 col-12 mt-3">
                    <input type="button" name="" value="جستجو" class="btn btn-success mt-2 w-100" @click="GetReport();$ResetTimer()" />
                </div> -->
        </div>
      </div>
    </div>
    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="mablaghGhestVam" slot-scope="props">
        {{props.row.mablaghGhestVam==null?'-':props.row.mablaghGhestVam}}
      </template>
      <template slot="mablaghVam" slot-scope="props">
        {{props.row.mablaghVam==null?'-':props.row.mablaghVam}}
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
    </vue-bootstrap4-table>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  data() {
    return {
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_ListMasdodi: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListMasdodi',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModel: null,
      IsLoad: false,
      Resultcmb: null,
      ResultcmbZemanat: null,
      ListModelZemanat: null,
      rows: [],
      listData: null,
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'توضیحات',
          name: 'sharh',
        },
        {
          label: 'شماره تسهیلات',
          name: 'vCode',
        },
        {
          label: 'شماره پس انداز',
          name: 'vcodePas',
        },
        {
          label: 'مشخصات',
          name: 'familyNameVamGirande',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط تسهیلات',
          name: 'mablaghGhestVam',
        },
        {
          label: 'تاریخ',
          name: 'tarix',
        },
        {
          label: 'مبلغ مسدودی',
          name: 'mablaghMasdodNemodan',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
    }
  },
  components: {
    panel,
    NetPaCard,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData()
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 2)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data
        this.Resultcmb = data[0].id
      })
      .finally(() => {
        this.GetReport()
      })
  },
  methods: {
    GetReport() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaIdPas', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('VcodeID', this.Resultcmb == -1 ? null : this.Resultcmb)
      this.DataAxios_ListMasdodi.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_ListMasdodi).then((data) => {
        if (data.length) {
          let info
          let list = []
          for (let index = 0; index < data.length; index++) {
            info = data[index]
            info['row'] = index + 1
            list.push(info)
          }
          this.rows = this.$FormatMablaghGrid(list)
          this.loadingRender = false
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
          this.config.pagination = false
          this.rows = []
          this.loadingRender = false
        }
      })
    },
  },
}
</script>
<style scoped></style>
